/**
 * McpReportCard Component
 *
 * Vertical card teaser for the "Create a report with MCP" feature where
 * an agency owner can connect their Claude / ChatGPT subscription and
 * generate reports via natural-language prompts.
 *
 * Currently grayed out / disabled — ships in a future Epic.
 */

import { BrainIcon } from "@phosphor-icons/react";

export function McpReportCard() {
  return (
    <div
      data-testid="mcp-report-card"
      className="relative overflow-hidden rounded-[30px] bg-card px-6 py-6 h-full shadow-sm opacity-60 pointer-events-none border-[0.5px] border-[var(--hairline)]"
    >
      {/* Coming soon badge */}
      <span className="absolute top-3 right-3 inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-muted text-muted-foreground">
        Coming soon
      </span>

      <div className="flex flex-col items-center text-center gap-3 h-full">
        <BrainIcon size={24} className="text-foreground" />
        <div>
          <h3 className="text-base font-semibold text-foreground">
            Create a Report with AI
          </h3>
          <p className="text-sm text-foreground/70 mt-1">
            Connect Claude or ChatGPT, describe what you need, and your AI
            assistant will build the report for you.
          </p>
        </div>
      </div>
    </div>
  );
}
